import React from 'react';
import Heading from '@/components/heading/Heading';
import Footer from '@/pages/home/components/Footer';
import './helpCentre.css';

interface HelpCentreLayoutProps {
  children: React.ReactNode;
  /**
   * The hub renders on the shared `--hc-bg` grey page with white cards. The
   * article page inverts that: it renders on white (`--hc-page-bg` resolves
   * to `--hc-surface`) so the grey accent fills (the read-time pill, the
   * "On this page" card, the Previous/Next cards) read as distinct surfaces
   * instead of grey-on-grey. Defaults to 'hub'.
   */
  page?: 'hub' | 'article';
}

/**
 * Site chrome plus the help centre's own background and tokens.
 *
 * The existing Heading and Footer are reused deliberately — the rest of the
 * site has not moved to this design yet, so a second nav would have to be
 * maintained in parallel.
 */
export const HelpCentreLayout = ({
  children,
  page = 'hub',
}: HelpCentreLayoutProps): React.JSX.Element => (
  <>
    <Heading />
    <div className={page === 'article' ? 'hc hc-article-page' : 'hc'}>{children}</div>
    <Footer />
  </>
);

export default HelpCentreLayout;
